import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

// import images
import landing from "../../../assets/images/property-management/classic.png";
import akaunting from "../../../assets/images/property-management/akaunting-dashboard.png";

export default class Team extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg={5} md={6} className="order-1 order-md-2">
              <img
                src={landing}
                className="img-fluid rounded-md shadow-lg"
                alt=""
              />
            </Col>

            <Col
              lg={7}
              md={6}
              className="order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0"
            >
              <div className="section-title text-md-start text-center">
                <h4 className="title mb-4">
                  Stay on top of
                  <br /> your finances
                </h4>
                <p className="text-muted mb-0 para-desc">
                  Get total control over your rent payments and expenses.
                  {" "}
                  {/* <span className="text-primary fw-bold">
                    Landrick
                  </span>{" "} */}
                </p>

                <div className="d-flex align-items-center text-start mt-4">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-university" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                      Connect your bank account to automatically import transactions
                    </Link>
                  </div>
                </div>

                <div className="d-flex align-items-center text-start mt-4 pt-2">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-invoice" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                      Generate payment references for tenants, properties, leases, landlords and service providers
                    </Link>
                  </div>
                </div>

                <div className="d-flex align-items-center text-start mt-4">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-transaction" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                      Use the payment references in any bank transfer to automatically update your records.
                    </Link>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-100">

            <Col lg={5} md={6} className="order-1 order-md-1">
              <img
                src={akaunting}
                className="img-fluid rounded-md shadow-lg"
                alt=""
              />
            </Col>

            <Col
              lg={7}
              md={6}
              className="order-2 order-md-2 mt-4 pt-2 mt-sm-0 pt-sm-0"
            >
              <div className="section-title text-md-start text-center">
                <h4 className="title mb-4">
                  Fully Integrated<br /> Accounting Module
                </h4>
                <p className="text-muted mb-0 para-desc">
                  From invoicing to expense tracking to accounting, Akaunting has all the tools you need to manage your money online, for free.
                  {" "}
                  {/* <span className="text-primary fw-bold">
                    Landrick
                  </span>{" "} */}
                </p>

                <div className="d-flex align-items-center text-start mt-4 pt-2">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-university" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                    Stay on top of your Cashflow and make smarter decisions about your business.
                    </Link>
                  </div>
                </div>

                <div className="d-flex align-items-center text-start mt-4">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-transaction" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                    Keep track of your mounting bills & expenses and the money flowing out.
                    </Link>
                  </div>
                </div>

                <div className="d-flex align-items-center text-start mt-4">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-grid" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                    Create unlimited bank and cash accounts and track their opening and current balances.
                    </Link>
                  </div>
                </div>

                <div className="d-flex align-items-center text-start mt-4">
                  <div className="text-primary h4 mb-0 me-3 p-3 rounded-md shadow">
                    <i className="uil uil-invoice" style={{ color: "#f7961c" }}></i>
                  </div>
                  <div className="flex-1">
                    <Link to="#" className="text-dark h6">
                    Get detailed financial reports to help you better visualize all the information you need to improve your business.
                    </Link>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
